import { Stack, Typography } from '@mui/material';
import React from 'react';

import { InfoIcon } from '@/shared/assets/icons/info-icon';
import { TIdeVersionLabelProps } from '@/shared/components/ui/ide-version-label/ide-version-label.types';
import { Tooltip } from '@/shared/components/ui/tooltip/tooltip';
import { useVendor } from '@/shared/hooks/use-vendor/use-vendor';

export const IdeVersionLabel: React.FC<TIdeVersionLabelProps> = ({
  vendorId,
  ideConfigId,
  variant = 'p7',
  color,
}) => {
  const { getIde } = useVendor();
  const ide = getIde({ vendorId, ideConfigId });

  if (!ide?.name) {
    return null;
  }

  return (
    <Stack direction="row" gap="0.375rem" alignItems="center" height="100%">
      <Typography variant={variant} color={color}>
        {ide.name}
      </Typography>
      {ide.additionalInformation && (
        <Tooltip title={ide.additionalInformation} placement="right">
          <InfoIcon color="textSecondary" size="1rem" />
        </Tooltip>
      )}
    </Stack>
  );
};
